import DateFilter from "../shared/DateFilter";
import Placeholder from '../Placeholder';
import React, {useEffect, useState} from 'react';
import withDateFilter from "../../hocs/withDateFilter";
import withFiltering from "../../hocs/withFiltering";
import {apiFetch, titleize} from "../../utils";
import {compose} from "redux";
import {modals} from "../../ducks";
import {withRouter} from "react-router";

import './LeadSourceReport.scss';
import AdmissionsReportNav from "./AdmissionsReportNav";
import {connect} from "react-redux";


const Roles = ["lead", "prospect"];

const Stages = ["inquiry", "applicant", "application_complete", "accepted", "enrollment"];

const Columns = [
  ...Roles.map(role => ["role", role]),
  ...Stages.map(stage => ["stage", stage])
];

const lookupCell = (report, leadSource, kind, value) => {
  let v = report.data[leadSource];
  if (v) {
    v = v[kind];
  }
  if (v) {
    v = v[value];
  }
  return v;
};

const summarize = (report) => {
  const totals = {source: {}, role: {}, stage: {}, grandTotal: 0};

  Object.keys(report.data).forEach(leadSource => {
    const roles = report.data[leadSource]["role"] || [];
    const stages = report.data[leadSource]["stage"] || [];

    totals.source[leadSource] = 0;

    for (const [role, value] of Object.entries(roles)) {
      if (totals.role[role] === undefined) {
        totals.role[role] = 0;
      }
      totals.role[role] += value;
      totals.source[leadSource] += value;
      totals.grandTotal += value;
    }

    for (const [stage, value] of Object.entries(stages)) {
      if (totals.stage[stage] === undefined) {
        totals.stage[stage] = 0;
      }
      totals.stage[stage] += value;
      totals.source[leadSource] += value;
      totals.grandTotal += value;
    }
  });

  return totals;
};


const LeadSourceReport = (
  {
    // withRouter
    location,

    // withDateFilter
    dateFilter,

    // mapDispatchToProps
    showModal,
  }
) => {
  const [ready, setReady] = useState(false);
  const [report, setReport] = useState({data: {}});

  const searchParams = new URLSearchParams(location.search);
  for (const [key, value] of Object.entries(dateFilter && dateFilter.queryParams || {})) {
    if (value) {
      searchParams.set(key, value);
    }
  }

  useEffect(() => {
    setReady(false);
    apiFetch.get({}, `reporting/lead_source_report?${searchParams}`)
      .then(json => setReport(json.lead_source_report))
      .catch(() => showModal('UnexpectedError'))
      .finally(() => setReady(true));
  }, [location.search]);

  const leadSources = Object.keys(report.data);
  leadSources.sort();
  const totals = summarize(report);

  return (<div className={"reporting"}>
    <h2>Lead Report</h2>

    <AdmissionsReportNav view={"leads"}/>

    <div className={"lead-source-filters"}>
      <DateFilter useFutureOptions={false} dateFilter={dateFilter}/>
    </div>

    <table className={"table lead-source-report"}>
      <Placeholder.table ready={ready}>
        <React.Fragment>
          <thead>
          <tr>
            <th className={"col-lead-source"}>Lead Source</th>

            {Columns.map(([kind, value]) =>
              <th key={`${kind}-${value}`} className={`col-${kind}`} width={"9%"}>
                {titleize(value)}
              </th>
            )}

            <th className={"col-total"} width={"9%"}>Total</th>
          </tr>
          </thead>

          {leadSources.length !== 0 &&
            <React.Fragment>
              <tbody>
              {leadSources.map(
                leadSource => {
                  return <tr key={leadSource}>
                    <td className={"col-lead-source"}>{leadSource}</td>

                    {Columns.map(([kind, value]) =>
                      <td key={`${kind}-${value}`} className={`col-${kind}`}>
                        {lookupCell(report, leadSource, kind, value)}
                      </td>
                    )}

                    <td className={"col-total"}>{totals.source[leadSource]}</td>
                  </tr>;
                }
              )}
              </tbody>

              <tfoot>
              <tr>
                <td>Total</td>

                {Columns.map(([kind, value]) =>
                  <td key={`${kind}-${value}`} className={`col-${kind}`}>
                    {(kind === "role" ? totals.role : totals.stage)[value]}
                  </td>
                )}

                <td>{totals.grandTotal}</td>
              </tr>
              </tfoot>
            </React.Fragment>
          }

          {leadSources.length === 0 && <tbody>
          <tr>
            <td>-</td>
            <td colSpan={Columns.length}>No data found</td>
            <td>-</td>
          </tr>
          </tbody>}
        </React.Fragment>
      </Placeholder.table>
    </table>
  </div>);
};

const mapDispatchToProps = (dispatch) => ({
  showModal: (type) => dispatch(modals.actions.show(type))
});

export default compose(
  withRouter,
  withFiltering,
  withDateFilter({defaultRange: 'all'}),
  connect(null, mapDispatchToProps)
)(LeadSourceReport);
